export function createReadableStreamFromBuffer(buffer: Buffer): ReadableStream {
  const uint8Array = new Uint8Array(buffer);

  return new ReadableStream({
    start(controller) {
      controller.enqueue(uint8Array);
      controller.close();
    },
  });
}

export async function dataItemStreamToArrayBuffer(
  data: unknown,
): Promise<ArrayBuffer> {
  if (data instanceof ReadableStream) {
    return new Response(data).arrayBuffer();
  }

  if (data instanceof ArrayBuffer) {
    return data;
  }

  if (ArrayBuffer.isView(data)) {
    const view = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    return view.slice().buffer;
  }

  if (
    typeof SharedArrayBuffer !== 'undefined' &&
    data instanceof SharedArrayBuffer
  ) {
    const view = new Uint8Array(data);
    return view.slice().buffer;
  }

  throw new Error('Unsupported data item stream type');
}
